import 'photoswipe/dist/photoswipe.css'

import React from 'react'
import { Item } from 'react-photoswipe-gallery'

type Props = {
  content: JSX.Element
  preview: JSX.Element
}
export const ViewModal: React.FC<Props> = ({ content, preview }) => {
  return (
    <Item<HTMLImageElement> content={content}>
      {({ ref, open }) => {
        return React.cloneElement(preview, { ref, onClick: open })
      }}
    </Item>
  )
}
